/* eslint-disable */
import storeApis from "../../api/storeApi";
import * as types from "../../constants/JourneyActionTypes";
import { toast } from "react-toastify";
import Toast from "../../components/assetLibComponents/shared/Toast";


export const setJourneyUnauthorized = () => {
    return (dispatch) => {
        dispatch({ type: "UNAUTHORIZED_JOURNEY", payload: null });
    };
};



export const createJourney = (authToken, id, title, segment, onSuccess) => {
    return async (dispatch) => {
        dispatch({ type: "TOGGLE_LOADING", payload: true });
        try {
            const response = await storeApis.post(
                "journeyBuilder/create_journey",
                {
                    title: title,
                    segment: segment,
                    id: id
                },
                {
                    headers: {
                        Accept: "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },

                }
            );

            if (response.status === 200) {
                if (response.data.statusCode == "403") {
                  dispatch({
                    type: "UNAUTHORIZED_JOURNEY",
                    payload: response.data.statusCode,
                  });
                  dispatch({ type: "TOGGLE_LOADING", payload: false });
                  // Toast(response.data.message, "E");
                } else {
                    Toast(`Journey ${id !== "" ? "updated" : "created"} successfully`,"S")
                    if (onSuccess) onSuccess(response.data.details);
                }
              }            
        } catch (err) {
            Toast(`Failed to ${id !== "" ? "update" : "create"} journey`, "E");
        } finally {
            dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
    };
};

export const saveJourneyData = (authToken, journeyId, journeyData , onSuccess) => {
    return async (dispatch) => {
        dispatch({ type: "TOGGLE_LOADING", payload: true });
        try {
            const response = await storeApis.post(
                "journeyBuilder/create",
                {
                    journey_id: journeyId,
                    nodes: journeyData.nodes,
                    edges: journeyData.edges,
                    metadata: journeyData.metadata
                },
                {
                    headers: {
                        Accept: "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );

            if (response.status === 200) {
                if (response.data.statusCode == "403") {
                  dispatch({
                    type: "UNAUTHORIZED_JOURNEY",
                    payload: response.data.statusCode,
                  });
                  dispatch({ type: "TOGGLE_LOADING", payload: false });
                  // Toast(response.data.message, "E");
                } else {
                    if (onSuccess) onSuccess();
                }
              }             
        } catch (err) {
            Toast("Failed to save journey", "E");
            console.error("Save journey error:", err);
        } finally {
            dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
    };
};

export const fetchJourneyListing = (authToken) => {
    return async (dispatch) => {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      try {
        const response = await storeApis.get(
          "journeyBuilder/list",
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_JOURNEY",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // Toast(response.data.message, "E");
          } else {
            await dispatch({
              type: types.JOURNEY_LISTING,
              payload: response.data,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // Toast(response.data.message, "S");
          }
        }
      } catch (err) {
        dispatch({ type: "TOGGLE_LOADING", payload: false });
        dispatch({
          type: "UNAUTHORIZED_CHAT_AI",
          payload: err.response.status,
        });
      }
    };
  };

export const fetchJourneyDetails = (authToken, journeyId, callback) => {
    return async (dispatch) => {
        dispatch({ type: "TOGGLE_LOADING", payload: true });
        try {
            const response = await storeApis.post(
                "journeyBuilder/details",
                {
                    journey_id: journeyId
                },
                {
                    headers: {
                        Accept: "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );
            if (response.status === 200) {
                if (response.data.statusCode == "403") {
                  dispatch({
                    type: "UNAUTHORIZED_JOURNEY",
                    payload: response.data.statusCode,
                  });
                  dispatch({ type: "TOGGLE_LOADING", payload: false });
                  // Toast(response.data.message, "E");
                } else {
                    dispatch({ 
                        type: "SET_JOURNEY_DETAILS", 
                        payload: response.data 
                    });
                    if (callback) {
                        callback(response.data.details);
                    }
                }
              } 
        } catch (error) {
            console.error('Error fetching journey details:', error);
            // Dispatch error action if needed
            dispatch({
                type: 'FETCH_JOURNEY_DETAILS_ERROR',
                payload: error.message,
            });
            
            // Call the callback with null to indicate error
            if (callback) {
                callback(null);
            }
        }
    };
};
